module.exports = __webpack_public_path__ + "img/form-icon-password.aa786207.svg";